



import { ArrowBack, Instagram } from '@mui/icons-material'; // Import ArrowBack
import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation, useNavigate } from 'react-router-dom';

const BrandInfoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { brandId } = location.state || {}; // Get brandId from location.statesssss

  // State for loading delay and data
  const [loading, setLoading] = useState(true);
  const [brandData, setBrandData] = useState(null);
  const [deviceType, setDeviceType] = useState('');

  // Simulate loading delay of 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false); // Stop the skeleton loader after 10 seconds
    }, 1000); // Set to 10 seconds
    return () => clearTimeout(timer);
  }, []);

  // Detect device type (mobile, tablet, desktop)
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setDeviceType('mobile');
      } else if (width > 768 && width <= 1024) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };

    handleResize(); // Check on initial load
    window.addEventListener('resize', handleResize); // Check on window resize
    return () => window.removeEventListener('resize', handleResize); // Cleanup on unmount
  }, []);

  // Fetch brand and campaign data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://server-side-influencer.onrender.com/influencer/brand/${brandId}`);
        const data = await response.json();
        setBrandData(data); // Set the fetched data to the state
      } catch (error) {
        console.error("Error fetching brand data:", error);
      }
    };

    if (brandId) {
      fetchData();
    }
  }, [brandId]);

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous screen
  };

  return (
    <div className="flex h-screen mb-0">
      {/* Header Section */}
      <div className="h-screen ml-0 sm:ml-0 w-screen">
        <div className="flex justify-between items-center p-4 ml-9">
          <button onClick={handleBackClick} className="text-black">
            <ArrowBack /> Back {/* Material-UI Back Arrow Icons */}
          </button>
          <h1 className="text-1xl font-bold text-black ml-4">Brand Info</h1>
        </div>

 


 {/* Background Section with Skeleton */}
<div className="relative h-64 bg-gray-200">
  {loading || !brandData ? (
    <Skeleton height="100%" width="100%" />
  ) : (
    <>
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${brandData.brand.backgroundImage}')` }}
      ></div>
      <div className="absolute inset-0 bg-black bg-opacity-30"></div>

      {/* Profile Image Section */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
        <img
          className="w-28 h-28 rounded-full border-4 border-white shadow-lg object-cover"
          src={brandData.brand.profilePic || 'https://res.cloudinary.com/...'}
          alt="Brand Profile"
        />
      </div>
    </>
  )}
</div>

{/* Title and Description */}
<div className="p-6">
  {loading || !brandData ? (
    <>
      <Skeleton height={40} width="60%" className="mx-auto mb-4" />
      <Skeleton count={2} width="80%" className="mx-auto mb-4" />
    </>
  ) : (
    <>
      <h2 className="text-4xl font-bold text-center mb-4">{brandData.brand.shopName}</h2>
      <p className="text-lg text-center mb-4">{brandData.brand.description}</p>
      <div className="text-lg font-bold text-left mt-4">Live campaigns</div>
    </>
  )}
</div>

{/* Campaign Cards */}
<div className="p-6">
  <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6`}>
    {loading || !brandData ? (
      // Show 3 skeleton cards
      Array(3).fill(0).map((_, i) => (
        <Skeleton key={i} height={260} className="rounded-lg" />
      ))
    ) : (
      brandData.campaigns.map((campaign) => (
        <div
          key={campaign._id}
          className="relative bg-fit-cover bg-center h-64 rounded-lg overflow-hidden shadow-lg"
          style={{ backgroundImage: `url('${campaign.campaignImages[0]}')` }}
          onClick={() => {
            navigate("/campaigndetails", { state: { campaignDetails: campaign } });
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
            <img
              className="w-12 h-12 rounded-full border-4 border-white shadow-lg object-cover"
              src={brandData.brand.profilePic || 'https://via.placeholder.com/100'}
              alt="Campaign Profile"
            />
          </div>
          <div className="absolute bottom-4 left-0 right-0 flex justify-center items-center text-white space-x-2">
            <Instagram />
            <span>{campaign.followerRange[0]}-{campaign.followerRange[1]} followers</span>
          </div>
        </div>
      ))
    )}
  </div>
</div>
</div>
</div>

  );
};

export default BrandInfoPage;

